import {
	Addtocalendar,
	AddtocalendarType
} from 'blocks/addtocalendar/addtocalendar'
import {Contact, ContactType} from 'blocks/contact/contact'
import {Eventsblock, EventsblockType} from 'blocks/eventsblock/eventsblock'
import React from 'react'
import {style} from 'util/style'
import {Buttonsblock, ButtonsblockType} from './buttonsblock/buttonsblock'
import {Columns4, Columns4Type} from './columns4/columns4'
import {Eloqua, EloquaType} from './eloqua/eloqua'
import {
	Featuredspeakers,
	FeaturedspeakersType
} from './featuredspeakers/featuredspeakers'
import {Gallery, GalleryType} from './gallery/gallery'
import {Iframe, IframeType} from './iframe/iframe'
import {Imagetext, ImagetextType} from './imagetext/imagetext'
import {Infographic, InfographicType} from './infographic/infographic'
import {Location, LocationType} from './location/location'
import {Sponsorblock, SponsorblockType} from './sponsorblock/sponsorblock'
import {Sponsors, SponsorsType} from './sponsors/sponsors'
import {Subscribe, SubscribeType} from './subscribe/subscribe'
import {Summits, SummitsType} from './summits/summits'
import {Summitsbar, SummitsbarType} from './summitsbar/summitsbar'
import {Text, TextType} from './text/text'
import {Titletext, TitletextType} from './titletext/titletext'

export type BlockType =
	| ({type: 'buttonsblock'} & ButtonsblockType)
	| ({type: 'columns4'} & Columns4Type)
	| ({type: 'featuredspeakers'} & FeaturedspeakersType)
	| ({type: 'gallery'} & GalleryType)
	| ({type: 'iframe'} & IframeType)
	| ({type: 'imagetext'} & ImagetextType)
	| ({type: 'infographic'} & InfographicType)
	| ({type: 'location'} & LocationType)
	| ({type: 'sponsorblock'} & SponsorblockType)
	| ({type: 'sponsors'} & SponsorsType)
	| ({type: 'subscribe'} & SubscribeType)
	| ({type: 'summits'} & SummitsType)
	| ({type: 'summitsbar'} & SummitsbarType)
	| ({type: 'text'} & TextType)
	| ({type: 'titletext'} & TitletextType)
	| ({type: 'contact'} & ContactType)
	| ({type: 'addtocalendar'} & AddtocalendarType)
	| ({type: 'eloqua'} & EloquaType)
	| ({type: 'eventsblock'} & EventsblockType)
	| {type: 'custom'; render: () => any}

const styles = style('block')

export const Block: React.FC<BlockType> = block => {
	switch (block.type) {
		case 'buttonsblock':
			return <Buttonsblock {...block} />
		case 'columns4':
			return <Columns4 {...block} />
		case 'featuredspeakers':
			return <Featuredspeakers {...block} />
		case 'gallery':
			return <Gallery {...block} />
		case 'iframe':
			return <Iframe {...block} />
		case 'imagetext':
			return <Imagetext {...block} />
		case 'infographic':
			return <Infographic {...block} />
		case 'location':
			return <Location {...block} />
		case 'sponsorblock':
			return <Sponsorblock {...block} />
		case 'sponsors':
			return <Sponsors {...block} />
		case 'subscribe':
			return <Subscribe {...block} />
		case 'summits':
			return <Summits {...block} />
		case 'summitsbar':
			return <Summitsbar {...block} />
		case 'text':
			return <Text {...block} />
		case 'titletext':
			return <Titletext {...block} />
		case 'contact':
			return <Contact {...block} />
		case 'eloqua':
			return <Eloqua {...block} />
		case 'addtocalendar':
			return <Addtocalendar {...block} />
		case 'eventsblock':
			return <Eventsblock {...block} />
	}

	return <p>Not yet supported type: {(block as any).type}</p>
}
